import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FieldCustomization, isVisibleFn, selectTenant } from 'state/tenant';

type FieldCustomizationHook = () => {
  isRequired: (name: keyof FieldCustomization) => boolean;
  isVisible: (name: keyof FieldCustomization) => boolean;
  isLastFour: () => boolean;
};

const useFieldCustomization: FieldCustomizationHook = () => {
  const tenant = useSelector(selectTenant);
  const { fieldCustomizations } = useSelector(selectTenant);

  const isVisible = useCallback(
    (name: keyof FieldCustomization): boolean => isVisibleFn(tenant, name),
    [tenant],
  );

  const isRequired = useCallback(
    (name: keyof FieldCustomization): boolean => {
      const config = fieldCustomizations[name];
      return !config.optional;
    },
    [fieldCustomizations],
  );

  const isLastFour = useCallback((): boolean => {
    const config = fieldCustomizations.ssn;
    return config.lastFourOnly;
  }, [fieldCustomizations]);

  return { isRequired, isVisible, isLastFour };
};

export default useFieldCustomization;
